import { useMemo } from 'react';

import type { NavigationGutterItem } from '~/@types/redux';
import AlertTabAccordion from '~/pages/Home/AlertTabAccordion';
import { SEARCH_MIN_CHARACTERS } from '~/pages/Home/constants';
import { useNavSearchStore } from '~/stores/useNavSearchStore';

import NavAlertItemsContainer from './NavAlertItemsContainer';
import useNavigationGutterItems from './useNavigationGutterItems';

export default function WorkNavAlertItems() {
  const navigationGutterItems = useNavigationGutterItems();
  const searchQuery = useNavSearchStore((s) => s.searchQuery);

  const filteredItems = useMemo(() => {
    if (searchQuery.trim().length < SEARCH_MIN_CHARACTERS)
      return navigationGutterItems;
    const q = searchQuery.toLowerCase();
    return navigationGutterItems.reduce<NavigationGutterItem[]>((acc, item) => {
      if (item.displayTitle.toLowerCase().includes(q)) {
        acc.push(item);
        return acc;
      }
      const matchingChildren = item.gutterItemChildren.filter((child) =>
        child.displayTitle.toLowerCase().includes(q),
      );
      if (matchingChildren.length > 0) {
        acc.push({ ...item, gutterItemChildren: matchingChildren });
      }
      return acc;
    }, []);
  }, [navigationGutterItems, searchQuery]);

  const isSearchActive = searchQuery.trim().length >= SEARCH_MIN_CHARACTERS;

  const appraisalCategory = 'Appraisals';

  return (
    <NavAlertItemsContainer
      ariaLabel="work items navigation"
      noResults={isSearchActive && filteredItems.length === 0}
    >
      {filteredItems.map((alert) => (
        <AlertTabAccordion
          key={alert.gutterItemId}
          alert={alert}
          groupHeader={
            alert.ruleSubCategoryName === appraisalCategory
              ? alert.displayTitle
              : undefined
          }
        />
      ))}
    </NavAlertItemsContainer>
  );
}
